import { createAppStore } from '@store/createAppStore';
import { createSignal } from 'solid-js';

import { UserDetailStoreType, UserDetailsType } from './types';

const [rolesUpdateTrigger, setRolesUpdateTrigger] = createSignal(false);
const [permissionsUpdateTrigger, setPermissionsUpdateTrigger] =
  createSignal(false);

const [userDetailStore, setUserDetailStore, resetUserDetailStore] =
  createAppStore<UserDetailStoreType>(
    {
      isLoading: false,
      userDetails: {} as UserDetailsType,
      currentUser: true,
      documents: [],
      postingGroup: [],
      roles: [],
      permissions: [],
      pendingChargeTypes: [],
      pendingCharges: [],
      pastCharges: [],
      loadingPendingCharges: false,
      pendingChargedErrors: null,
    },
    'userDetailStore',
  );

export {
  permissionsUpdateTrigger,
  resetUserDetailStore,
  rolesUpdateTrigger,
  setPermissionsUpdateTrigger,
  setRolesUpdateTrigger,
  setUserDetailStore,
  userDetailStore,
};
